import { log } from "@qgiv/core-js";
import { getParsedDataFromPostMessage } from "../postMessage";
import {
    getPaymentIframeElement,
    getPaymentIframeSubmissionEventName,
} from "./helpers";

/**
 * @typedef {import("./paymentIframeTypes").ParsedSuccessResponseFromPaymentIframe} ParsedSuccessResponseFromPaymentIframe
 */

const paymentIframeSubmissionEvent = getPaymentIframeSubmissionEventName();

/**
 *
 * @param {string} urlOfPaymentIframe
 * @returns {void}
 */
const sendRequestForCardTokenMessage = (urlOfPaymentIframe) => {
    const paymentIframe = getPaymentIframeElement();
    const elementToSendPostMessageTo = paymentIframe?.contentWindow;

    if (paymentIframe && !!elementToSendPostMessageTo) {
        const event = paymentIframeSubmissionEvent;
        const message = {
            event,
        };
        const targetOrigin = urlOfPaymentIframe;

        log(
            "HOST APPLICATION: SEND POST MESSAGE TO PAYMENT APP WITH SUBMISSION EVENT",
        );

        elementToSendPostMessageTo.postMessage(
            JSON.stringify(message),
            targetOrigin,
        );
    }
};

/**
 *
 * @description In order to successfully send this request we need to:
 * 1. Prepare data to send to the API endpoint.
 * 2. Send a post message that requests a CC submission token from the payment iframe.
 * 3. Add an event listener that monitors whether we have gotten a response to
 * our request for a CC submission token. The handler needs to then process the
 * data in the response and remove the event handler once the promise is fulfilled.
 * @param {string} urlOfPaymentIframe
 * @returns {Promise<ParsedSuccessResponseFromPaymentIframe>}
 */
export const sendRequestForCardToken = (urlOfPaymentIframe) => {
    const requestForCardToken = new Promise((resolve, reject) => {
        let handleIncomingPostMessage;

        /**
         *
         * @description Fulfills promise and removes the event listener that
         * was created to listen to a response to our request for a CC Payment
         * Token from the Payment iframe.
         * @param {ParsedSuccessResponseFromPaymentIframe} parsedMessage
         * @returns {void}
         */
        const handleCardTokenMessageResponse = (parsedMessage) => {
            const { data } = parsedMessage;
            if (data.success === true) {
                resolve(parsedMessage);
            } else {
                reject(parsedMessage);
            }
            window.removeEventListener("message", handleIncomingPostMessage);
        };

        /**
         *
         * @param {MessageEvent} message
         * @returns {void}
         */
        handleIncomingPostMessage = (message) => {
            const parsedMessage = getParsedDataFromPostMessage(message);
            if (parsedMessage.event === paymentIframeSubmissionEvent) {
                handleCardTokenMessageResponse(parsedMessage);
            }
        };

        sendRequestForCardTokenMessage(urlOfPaymentIframe);
        window.addEventListener("message", handleIncomingPostMessage);
    });

    return requestForCardToken;
};
